import type { ReactElement } from 'react';
import styles from './PluginNotConfiguredScreen.module.css';

/**
 * CA-11: `activation_type` sem entrada em `plugin_registry` — terminal, sem
 * retentativa (o problema é de cadastro, não transiente). Distinta da tela
 * de erro final de rede (`PluginErrorScreen`, CA-16), que oferece retry.
 */
export function PluginNotConfiguredScreen(): ReactElement {
  return (
    <main className={styles.container} aria-label="Ativação não configurada" role="main">
      <p className={styles.message} role="alert">
        Ativação não configurada para este evento.
      </p>
    </main>
  );
}
